/**
 * 函数需要加如下参数options:
 * {
 *  responseType: 'blob',
 * }
 * @param blob
 * @param fileName
 */
export function saveFile(blob, fileName) {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export function downloadBlobFile(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}


export function getFileNameFromResponse(response) {
  const disposition = response.headers?.['content-disposition'] || '';
  let fileName = 'downloaded_file';
  if (disposition && disposition.includes('filename=')) {
    const match = disposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      fileName = decodeURIComponent(match[1]);
    }
  }
  return fileName;
}


export function isDownloadFile(response: any): boolean {
  const contentType = response.headers?.['content-type'] || '';
  const isBlob = response.data instanceof Blob;
  const isDownload = contentType.includes('application/octet-stream') || contentType.includes('application/pdf') || contentType.includes('application/zip');
  return isBlob || isDownload;
}
